module.exports = __webpack_public_path__ + "static/media/muestrabrightcream.3871337d.png";